module.exports = __webpack_public_path__ + "static/media/2.7e71f31c.jpeg";